import { CKEditor } from '@ckeditor/ckeditor5-react';
import { Button, Grid } from '@material-ui/core';
import { updateDescriptionStudent } from '@webapps/business';
import {
  useAuth,
  useMutation,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import Row from 'components/Form/Row';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import * as yup from 'yup';

const editDescSchema = yup.object().shape({
  presentation: yup.string().required('Requis'),
});

const CardTheme = ({ theme, handleChangeTheme, themeSelected }) => {
  const {
    classes,
    css,
    cx,
    global,
    theme: { spacing },
  } = useStyles(styles);

  const { idUser } = useAuth();


  return (
    <div className={cx(classes.card, themeSelected === theme.id && css({ backgroundColor: '#C0D9FF' }))}
      onClick={() => handleChangeTheme(theme.id)}
    >
      <img className={classes.img} src={theme.image} alt={theme.name} />
      <div>{theme.name}</div>
    </div>
  );
};

const styles = () => ({
  card: {
    padding: '5px',
    borderRadius: '10px',
    // boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.1)',
    backgroundColor: '#fff',
    marginBottom: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: '10px',
    marginRight: '10px',
    cursor: 'pointer',
    maxWidth: "120px"

  },
  img: {
    width: '100%',
    maxWidth: '100px',
    height: 'auto',
    borderRadius: '10px',
    marginBottom: '10px',
    padding: '5px',

  }
});

CardTheme.propTypes = {

};

export default CardTheme;
